import styled from 'styled-components/macro';

export const Logo = styled.img`
	width: ${(props) => {
		if (!props.isMobile) {
			return '134px';
		} else {
			return props.extraLogos ? '66px' : '95px';
		}
	}};
`;
export const LogoBmwGroup = styled.img`
	width: ${(props) => {
		if (!props.isMobile) {
			return '88px';
		} else {
			return '48px';
		}
	}};
`;
export const LogoBmw = styled.img`
	width: ${(props) => {
		if (!props.isMobile) {
			return '40px';
		} else {
			return '22px';
		}
	}};
`;
export const LogoMini = styled.img`
	width: ${(props) => {
		if (!props.isMobile) {
			return '84px';
		} else {
			return '52px';
		}
	}};
`;
export const SeparadorImg = styled.div`
	width: 1px;
	height: 40px;
	background-color: #c1c1c1;
	margin: 0;
`;
